import { connect } from 'react-redux';

import { appActions } from 'app/app.actions';
import { AppState } from 'bootstrap.store';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { notificationActions } from '../../notifications/actions/notification';
import { presenceActions } from '../../presence/actions/presenceActions';
import * as personalActions from '../../settings/actions/personal';
import { hasFeature } from '../../shared/featureFlag';
import Profile from '../components/Profile';

const { notificationAdd, notificationRemoveByType } = notificationActions;
const {
  presenceSetStatus,
  presenceSetMedia,
  presenceSetMediaChannel,
  presenceSetSimultaneousRinging,
} = presenceActions;
const { personalToggleRememberMicrophoneAccess } = personalActions.actions;

const mapStateToProps = (state: AppState) => {
  return {
    presenceMeta: state.presence.meta,
    profile: state.settings.profile.profile,
    organization: state.settings.organization.organization,
    telephony: state.telephony,
    presence: state.presence.presence,
    hasPhoneChannel: hasFeature(state, 'phone-channel'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    presenceSetStatus: bindActionToPromise(dispatch, presenceSetStatus),
    presenceSetMedia: bindActionToPromise(dispatch, presenceSetMedia),
    presenceSetMediaChannel: bindActionToPromise(
      dispatch,
      presenceSetMediaChannel,
    ),
    presenceSetSimultaneousRinging: bindActionToPromise(
      dispatch,
      presenceSetSimultaneousRinging,
    ),

    notificationAdd: (payload) => dispatch(notificationAdd(payload)),
    notificationRemoveByType: (type: string) =>
      dispatch(
        notificationRemoveByType({
          type,
        }),
      ),

    errorMicrophoneErrorShowModal: (payload?: any) =>
      dispatch(
        appActions.showModal({
          modal: {
            type: 'app:microphoneError',
            arg: { ...(payload?.name && { error: payload.name }) },
          },
        }),
      ),
    showLogoutModal: () =>
      dispatch(
        appActions.showModal({
          modal: {
            type: 'app:logOut',
          },
        }),
      ),

    personalToggleRememberMicrophoneAccess: bindActionToPromise(
      dispatch,
      personalToggleRememberMicrophoneAccess,
    ),
  };
};

export type ProfileProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
